import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { RouterModule } from "@angular/router";
import { Cabecera } from "./cabecera.component";
import {FormsModule} from '@angular/forms';
import { DatosGeneralesService } from "../../../views/masivos/datosGenerales/datos-generales.service";
import { TimerModule } from "../timer/timer.module";


@NgModule({
    declarations: [Cabecera],
    imports: [BrowserModule, RouterModule, FormsModule, TimerModule],
    exports:[Cabecera],
    providers:[DatosGeneralesService]
})

export class CabeceraModule { }


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/components/common/cabecera/cabecera.module.ts